import React from 'react'
import ems from "../../../../assets/platform/ems.png";  

function Oee() {
    return (
        <div>
          <div className="energy-management-system">
            <div className="text-energy-management-system">
                OEE Platform
            </div>
            <div className="text-sub-energy-management-system">
              Norem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit <br /> interdum, ac aliquet odio mattis.
              Class aptent taciti sociosqu ad litora torquent per conubia nostra,
              per inceptos himenaeos.
            </div>
            <div className="button-energy-management-system">
              <a href="/" className="read-more-btn-ems">
                เรียนรู้เพิ่มเติม
              </a>
              <a href="/" className="buy-btn">
                ซื้อ
              </a>
            </div>
          </div>
          <div className="energy-management-system-platform">
            <div className="ems-platform-head">
              <div className="ems-platform-head-h1">OEE Platform</div>
              <div className="ems-platform-head-h2">
                For faster cloud digital transformation
              </div>
              <div className="ems-platform-head-h3">
                Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
                turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus
                nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum
                tellus elit sed risus. Maecenas eget condimentum velit.
              </div>
            </div>
            <div>
              <img
                src={ems}
                alt="platform-ems-by-xten"
                className="image-exp-platform"
              />
            </div>
            <div className="button-energy-management-system">
              <a href="/" className="console-btn-white">
                คอนโซล
              </a>
              <a href="/" className="buy-btn-black">
                ซื้อ
              </a>
            </div>
            <div className="box-energy-management-system">
              <div className="box-content-energy-management-system">
                <div className="text-headder-box-content-energy-management-system">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
                <div className="sub-headder-box-content-energy-management-system">
                  Jorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis. Class
                  aptent taciti sociosqu ad litora torquent per conubia nostra, per
                  inceptos himenaeos.
                </div>
              </div>
              <div className="box-content-energy-management-system">
                <div className="text-headder-box-content-energy-management-system">
                  Qorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
                <div className="sub-headder-box-content-energy-management-system">
                  Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                </div>
              </div>
              <div className="box-content-energy-management-system">
                <div className="text-headder-box-content-energy-management-system">
                  Sorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
                <div className="sub-headder-box-content-energy-management-system">
                  Korem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
              </div>
              <div className="box-content-energy-management-system">
                <div className="text-headder-box-content-energy-management-system">
                  Jorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
                <div className="sub-headder-box-content-energy-management-system">
                  Rorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                </div>
              </div>
            </div>
            <div className="text-pack">แพ็กเกจผลิตภัณฑ์</div>
            <div className="box-energy-management-system">
              <div className="box-pack-energy-management-system">
                <div className="box-pack-text-headder">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
                <div className="box-pack-text-sub">
                  Jorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis. Class
                  aptent taciti sociosqu ad litora torquent per conubia nostra, per
                  inceptos himenaeos.
                </div>
                <div className="box-pack-text-sub">
                  Torem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                </div>
                <div className="line-box"></div>
                <div className="none-box">
    
                </div>
                <div className="box-pack-text-headder">
                  Sorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
                <div className="box-pack-text-headder d-center">
                  $XXX.XX <span className="text-usd-year">
                    USD/Year
                  </span>
                </div>
                <div className="btn-buy-pack">
                    ซื้อ
                </div>
              </div>
              <div className="box-pack-energy-management-system">
                <div className="box-pack-text-headder">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
                <div className="box-pack-text-sub">
                  Jorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis. Class
                  aptent taciti sociosqu ad litora torquent per conubia nostra, per
                  inceptos himenaeos.
                </div>
                <div className="box-pack-text-sub">
                  Torem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                </div>
                <div className="line-box"></div>
                <div className="none-box">
    
                </div>
                <div className="box-pack-text-headder">
                  Sorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
                <div className="box-pack-text-headder d-center">
                  $XXX.XX <span className="text-usd-year">
                    USD/Year
                  </span>
                </div>
                <div className="btn-buy-pack">
                    ซื้อ
                </div>
              </div>
              <div className="box-pack-energy-management-system">
                <div className="box-pack-text-headder">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
                <div className="box-pack-text-sub">
                  Jorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis. Class
                  aptent taciti sociosqu ad litora torquent per conubia nostra, per
                  inceptos himenaeos.
                </div>
                <div className="box-pack-text-sub">
                  Torem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                </div>
                <div className="line-box"></div>
                <div className="none-box">
    
                </div>
                <div className="box-pack-text-headder">
                  Sorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
                <div className="box-pack-text-headder d-center">
                  $XXX.XX <span className="text-usd-year">
                    USD/Year
                  </span>
                </div>
                <div className="btn-buy-pack">
                    ซื้อ
                </div>
              </div>
            </div>
          </div>
        </div>
      );
}

export default Oee
